<template>
  <div class="mt-3 mt-md-6">
    <div class="d-flex flex-column align-center">
      <div class="grey--text text--darken-1 text-body-2 font-weight-regular">
        {{ title }}
      </div>

      <div class="d-flex mt-2 list-social">
        <v-btn
          v-for="({ className, title, icon, link, target }, index) in links"
          :class="['list-item', className]"
          color="grey lighten-2"
          :target="target"
          :title="title"
          :href="link"
          :key="index"
          height="46"
          width="46"
          outlined
          fab
        >
          <v-icon class="item-icon" color="grey darken-1">{{ icon }}</v-icon>
        </v-btn>
      </div>
    </div>

    <div
      class="grey--text text-caption text-md-body-2 text-center font-weight-regular mt-3 mt-md-6"
    >
      {{ copy }}
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterHome",
  data: () => ({
    title: "Siga-nos nas redes sociais",
    links: [
      {
        className: "instagram",
        title: "Instagram",
        icon: "mdi-instagram",
        link: "https://www.instagram.com/cantoacantoimoveis",
        target: "_blank",
      },
      {
        className: "facebook",
        title: "Facebook",
        icon: "mdi-facebook",
        link: "https://www.facebook.com/cantoacantoimoveis",
        target: "_blank",
      },
      {
        className: "youtube",
        title: "YouTube",
        icon: "mdi-youtube",
        link: "https://www.youtube.com/@canto-a-canto-imoveis",
        target: "_blank",
      },
      {
        className: "email",
        title: "E-mail",
        icon: "mdi-email-outline",
        link: "mailto:contato@cantoacanto.com.br",
        target: "_self",
      },
    ],
    copy: `© ${new Date().getFullYear()} Canto a Canto Imóveis. Todos os direitos reservados.`,
  }),
};
</script>

<style lang="scss" scoped>
.list-social {
  gap: 8px;

  .list-item {
    transition: all 0.18s ease;

    .item-icon {
      transition: all 0.18s ease;
    }

    &:hover {
      &.instagram {
        background-color: rgba(225, 48, 108, 0.1) !important;
        border-color: #e1306c !important;

        .item-icon {
          color: #e1306c !important;
        }
      }

      &.facebook {
        background-color: rgba(66, 103, 178, 0.1) !important;
        border-color: #4267b2 !important;

        .item-icon {
          color: #4267b2 !important;
        }
      }

      &.youtube {
        background-color: rgba(255, 0, 0, 0.1) !important;
        border-color: #ff0000 !important;

        .item-icon {
          color: #ff0000 !important;
        }
      }

      &.email {
        background-color: rgba(40, 40, 40, 0.1) !important;
        border-color: #282828 !important;

        .item-icon {
          color: #282828 !important;
        }
      }
    }
  }
}
</style>
